module.exports = "<section class=\"layer2\" [style.background]=\"'url('+img+')'\" ></section>\n<img class=\"layer1 img-fluid\"  src=\"{{img}}\" alt=\"\">\n\n"